import React, { Component, memo } from 'react'
import PropTypes from 'prop-types'
import Button from '../Button'

export const ICON_PERIOD = 'Etappe'
export const ICON_COMPANY = 'Firmengruppe'
export const ICON_TOPIC = 'Thema'

const icons = {
  [ICON_PERIOD]: 'flag',
  [ICON_COMPANY]: 'group',
  [ICON_TOPIC]: 'book',
}

class Topic extends Component {
  static propTypes = {
    text: PropTypes.string,
    icon: PropTypes.oneOf(Object.keys(icons)).isRequired,
    onClick: PropTypes.func,
    inverse: PropTypes.bool,
  }

  static defaultProps = {
    text: '',
    inverse: true,
    onClick: x => x,
  }

  // FEATURE: (1) Zoom to fit topic companies
  handleClick = e => {
    const { onClick, id } = this.props
    onClick(id)
  }

  render() {
    const { onClick, icon, ...rest } = this.props
    return (
      <Button
        {...rest}
        type="chip"
        size="small"
        icon={icons[icon]}
        onClick={this.handleClick}
      />
    )
  }
}

export default memo(Topic)
